















import Vue from 'vue';

export default Vue.extend({
  name: 'HTextarea',
  props: {
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    counter: {
      type: Number,
      default: 3000,
    },
    rows: {
      type: Number,
      default: 1,
    },
    grow: {
      type: Boolean,
      default: true,
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    maxRows: {
      type: Number,
      default: 20,
    },
    minRows: {
      type: Number,
      default: 1,
    },
    noResize: {
      type: Boolean,
      default: true,
    },
    autoGrow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      rowSize: this.rows,
    };
  },
  watch: {
    grow(newValue) {
      if (newValue) {
        this.growRowSize();
        return;
      }

      this.shrinkRowSize();
    },
  },
  methods: {
    growRowSize() {
      this.rowSize = this.maxRows;
    },
    shrinkRowSize() {
      this.rowSize = this.minRows;
    },
  },
});
